import React from 'react';

const jQuery_DOM = () => {
  return (
    <div >
      <h1>jQuery_DOM</h1>
      <p>Placeholder component for: "jQuery DOM"</p>
    </div>
  );
};

export default jQuery_DOM;
